interface Props {
  value: number; // 0..100
  size?: number;
  color?: string;
  label?: string;
  className?: string;
}

/** Anello probabilità: ring colorato + percentuale al centro. */
export function ProbabilityRing({
  value,
  size = 64,
  color,
  label = "YES",
  className = "",
}: Props) {
  const stroke = Math.max(3, size / 12);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value)) / 100;
  const ringColor = color ?? (pct >= 0.5 ? "var(--yes)" : "var(--no)");
  const fontSize = Math.max(11, size / 4.5);
  const labelSize = Math.max(9, size / 9);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        stroke="var(--bg-3)"
        strokeWidth={stroke}
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        stroke={ringColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        fill="none"
        strokeDasharray={`${c * pct} ${c}`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dasharray 700ms var(--ease)" }}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        fill="var(--text)"
        fontWeight={600}
        fontSize={fontSize}
        fontFamily="JetBrains Mono, monospace"
      >
        {Math.round(value)}%
      </text>
      {size >= 80 && (
        <text
          x="50%"
          y={size / 2 + fontSize * 0.9}
          textAnchor="middle"
          fill="var(--muted)"
          fontSize={labelSize}
          letterSpacing="0.08em"
        >
          {label}
        </text>
      )}
    </svg>
  );
}
